import React, { useRef, useState } from 'react';
import classnames from 'classnames';

import { Popover, PopoverAlign, PopoverPosition } from '../popover/popover';
import ChevronSVG from '../../../images/svg/icons8-expand-arrow';
import './select.scss';
import { getBtnModifiersClasses } from '../../../infrastructure/helpers';

export interface IOption {
    label: string;
    value: string | number;
    icon?: React.ComponentClass | React.FunctionComponent;
}

export interface ButtonProp {
    placeholder?: string | JSX.Element;
    options: IOption[];
    value: string | number;
    onChange: (value: string | number) => void;
    className?: string | null;
    disabled?: boolean;
    position?: PopoverPosition;
    align?: PopoverAlign;
    padding?: number;
    withChevron?: boolean;
}

const Select = (props: ButtonProp) => {
    const [isOpen, toggleOptions] = useState(false);
    const buttonRef = useRef(null);

    const {
        placeholder = '',
        options,
        value,
        onChange,
        className,
        disabled,
        withChevron = false,
        ...otherProps
    } = props;

    const btnClasses = classnames(
        'select-button',
        { 'select-button--active': isOpen },
        getBtnModifiersClasses('link'),
        className
    );

    return (
        <button
            className={btnClasses}
            disabled={disabled}
            ref={buttonRef}
            onBlur={() => toggleOptions(false)}
            onClick={() => toggleOptions(!isOpen)}
        >
         	<div className='select-button__content'>
	            <span className='select-button__label'>
                    {options.find(option => option.value === value)?.label || placeholder}
                </span>
	            { withChevron &&
	                <div className='select-button__chevron' >
	                    <ChevronSVG />
	                </div>
	            }
            </div>
	        <Popover
                buttonRef={buttonRef}
                isOpen={isOpen}
                align='center'
                position='top'
                padding={0}
                {...otherProps}
            >
	                {options.map(option => {
	                    return (
	                        <div
                                key={option.value}
	                            className={classnames('select-button__option',
                                    { 'select-button__option--selected': option.value === value })
                                }
	                            onClick={() => onChange(option.value)}
	                        >
	                            {option.icon && <option.icon />}
	                            {option.label}
	                        </div>
	                    );
	                })}
	            </Popover>
        </button>
    );
};

export default Select;
